import React, { useState, useEffect } from "react";
import Avatar from "../../assets/Avatar2.png"; // فرضی: آدرس عکس پروفایل

const ProfileProgress = () => {
  const [progress, setProgress] = useState(0);

  const profileSections = {
    personalInfo: true,
    skills: true,
    experience: false,
    education: false,
    photoUploaded: true,
  };

  const sectionWeights = {
    personalInfo: 10,
    skills: 20,
    experience: 30,
    education: 20,
    photoUploaded: 20,
  };

  useEffect(() => {
    let total = 0;
    for (const key in profileSections) {
      if (profileSections[key]) {
        total += sectionWeights[key];
      }
    }
    setProgress(total);
  }, [profileSections]);

  const radius = 40;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-24 h-24 flex items-center justify-center">
        <svg
          className="absolute top-0 left-0 w-full h-full"
          viewBox="0 0 100 100"
        >
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke="#e5e7eb"
            strokeWidth="6"
          />
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke="#10b981"
            strokeWidth="6"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 50 50)"
          />
        </svg>

        <img
          src={Avatar}
          alt="Profile"
          className="rounded-full w-20 h-20 object-cover"
        />
      </div>
      <p className=" text-xs font-semibold text-gray-600">
        {progress}% Complete
      </p>
    </div>
  );
};

export default ProfileProgress;
